<template>
  <p>Wylogowywanie użytkownika...</p>
</template>

<script>
import AuthService from "./auth.service.js";
export default {
  name: "signOutCallback",
  mounted: () => {
      AuthService.endSignout();
  }
};
</script>